import { OrderStatus, ErrorCode } from '@triplabo/web/services/types';

export default {
  views: {
    dashboard: {
      title: '儀表板'
    },
    home: {
      title: 'GO×旅日打車',
      greeting: '嗨，我們出發吧!',
      go: '日本第一打車平台GO提供服務',
      loginButton: '立即登錄',
      destinationPlaceholder: '您要去哪裡？',
      pickUp: '上車',
      recommendPickup: '推薦上車點',
      recommendDropOff: '推薦下車點',
      cannotUsePoint: '禁止載客區',
      nowPlace: '現在地',
      nowPlaceJa: '現在地',
      categories: {
        recommend: '推薦',
        transportation: '交通',
        attraction: '景點',
        experience: '體驗'
      },
      viewDetail: '查看',
      status: {
        finding: {
          title: '正在呼叫車輛',
          subtitle: '請您耐心等待'
        },
        dispatching: {
          subtitle: '司機馬上就到'
        },
        pickUpArrived: {
          subtitle: '司機到達, 請盡快聯繫'
        },
        onDeliver: {
          subtitle: '車輛行駛中'
        }
      }
    },
    pickup: {
      title: '選擇上車點',
      searchPlaceholder: '請輸入上車點',
      recommendTitle: '為您推薦附近的上車點',
      historyTitle: '歷史記錄',
      empty: '暫無數據',
      emptyTip: '換個詞試試，或用"地圖選點"即刻發單',
      emptyButton: '地圖選點',
      deleteConfirm: '確認刪除嗎？',
      deleteConfirmRecall: '確認',
      deleteConfirmCancel: '取消',
      facilityTag: '推薦'
    },
    pointChange: {
      searchUpPlaceholder: '請輸入上車點',
      searchDownPlaceholder: '請輸入下車點',
      title: '上車點變更',
      titleDropOff: '下車點變更',
      description: '拖動地圖指針，可更改上車位置',
      descriptionDropOff: '拖動地圖指針，可更改下車位置',
      confirm: '確認上車點',
      confirmDropOff: '確認下車點'
    },
    dropOff: {
      title: '選擇下車點',
      searchPlaceholder: '請輸入下車點',
      recommendTitle: '為您推薦附近的下車點'
    },
    orderConfirm: {
      discountApplied: '已優惠',
      paymentTimeoutDialog: {
        description: '系統繁忙, 請聯繫客服退款',
        subtitle: '請先截圖保存，然後聯繫客服退款',
        goToService: '我已截圖，去客服中心',
        orderIdLabel: '訂單號'
      },
      paymentProcessing: '訂單確認中，請勿關閉',
      ascfPayConfirm: {
        content: '支付已完成嗎？',
        confirm: '確定',
        notPaid: '支付未確認，請在"我的行程"中查看訂單狀態。'
      },
      title: '現在打車，上車更快！',
      selectType: '選擇車型',
      normal: '經濟型的士',
      premium: '豪華型的士',
      wagon: '舒適型的士',
      airport: '機場優惠定額',
      airportTag: '固定費用',
      airportTip: '日圓固定金額，實際金額以當日支付平均匯率結算',
      confirm: '立即呼叫',
      time: '約{{min}}-{{max}}分鐘上車',
      estimate: '預估',
      estimateTag: '預估車費',
      discount: '已優惠',
      unit: '元',
      coupon: '優惠券',
      couponAvailable: '{{count}} 張可用',
      checkOrderFailed: '檢查訂單狀態失敗，請稍後再試',
      callWaiting: {
        title: '當前附近無車輛是否繼續呼叫？',
        subtitle: '我們將持續為您尋找可用車輛，並在找到後立即通知您',
        confirm: '繼續呼叫',
        cancel: '取消呼叫',
        finding: '正在尋找附近車輛...',
        dispatching: '車輛調度中，請耐心等待',
        continueWaiting: '附近沒有車輛，是否繼續等待？',
        continue: '繼續等待',
        unwait: '不等了'
      }
    },
    profile: {
      title: '我的',
      order: '我的行程',
      coupon: '優惠券',
      service: '客服中心',
      userName: '用戶名',
      editProfile: '編輯資料',
      notLogin: '未登錄',
      goToLogin: '登錄賬戶',
      logout: '退出登錄',
      creditCard: '信用卡管理'
    },
    editUserInfo: {
      title: '修改個人信息',
      name: '姓名（拼音）',
      email: '聯繫郵箱（收取電子收據）',
      phone: '聯繫電話',
      confirm: '確認修改',
      emailError: '請輸入正確的郵箱地址',
      phoneError: '請輸入正確的手機號碼',
      nameError: '請輸入正確的姓名',
      success: '修改成功',
      error: '修改失敗，請稍後再試'
    },
    order: {
      all: '全部',
      succeed: '已完成',
      pending: '待支付',
      canceled: '已取消',
      empty: '暫無訂單',
      emptyTip: '快去呼叫用車吧',
      noMore: '沒有更多了',
      orderId: '訂單號',
      carType: {
        normal: '經濟型',
        premium: '豪華型',
        wagon: '舒適型',
        airport: '機場定額',
        any: '經濟型'
      },
      status: {
        [OrderStatus.Succeed]: '已完成',
        [OrderStatus.Canceled]: '已取消',
        [OrderStatus.Finding]: '呼叫中',
        [OrderStatus.DispatchFailed]: '呼叫中',
        [OrderStatus.Dispatching]: '行程中',
        [OrderStatus.PickUpArrived]: '行程中',
        [OrderStatus.OnDeliver]: '行程中',
        [OrderStatus.DropOff]: '已完成',
        pending: '待支付'
      },
      money: '{{amount}}'
    },
    payment: {
      title: '預付車費',
      description:
        '為確保順利發單，請您按照預估價支付車費，行程結束後按實際費用多退少補。',
      wechat: '微信支付',
      wechatDesc: '使用人民幣支付，適用於大陸微信用戶',
      agreement: '我已認真閱讀並同意',
      agreementLink: '《預付款協議》',
      confirm: '預支付{{amount}}元',
      money: '{{amount}}<span>元</span>',
      support: '支持'
    },
    cancelOrder: {
      success: '訂單已取消',
      confirmCancel: {
        title: '確認取消訂單',
        warning: '當您取消訂單時，可能會產生取消費用，請您確認是否要取消訂單？',
        note: '為維護良好打車生態，頻繁取消可能會被限制下單，感謝您的支持和理解！',
        viewRules: '查看取消規則',
        waitMore: '我再等等',
        confirm: '取消訂單',
        cancelFee: '取消費',
        cancelFeeDescription: '{{amount}}元'
      },
      selectReason: {
        title: '選擇取消原因',
        submit: '確認提交',
        otherReason: '其他原因',
        customReasonPlaceholder: '如有其他原因，請在這裡告訴我們',
        reasons: {
          platform: {
            title: '平台相關',
            content: {
              tooFar: '平台派單太遠',
              inaccurateLocation: '定位不準/找不到上車位置',
              notExpectedCar: '不是我預期的車型'
            }
          },
          driver: {
            title: '司機相關',
            content: {
              driverNotComing: '司機不來接我（車不動/離我越來越遠）',
              driverNotContactable: '聯繫不上/找不到司機',
              driverCancel: '司機要求取消訂單',
              driverLate: '司機遲到',
              driverNotMatch: '不是訂單顯示車輛或司機'
            }
          },
          self: {
            title: '自身原因',
            content: {
              selfChange: '自身行程有變，暫時不用車',
              otherPlatform: '在其他平台打到車',
              cannotArrive: '無法及時趕到上車點'
            }
          }
        }
      }
    },
    fareEstimate: {
      title: '車費預估',
      unit: 'JPY',
      hero: {
        title: '車費預估說明',
        subtitle: '應答快、接駕快、性價比優選'
      },
      fee: {
        title: '費用構成預估',
        totalLabel: '預估金額',
        approx: '約',
        range: '{{min}}~{{max}}',
        items: {
          transport: '運輸費（含手續費）',
          carTypeFee: '車型費',
          pickup: '迎車費',
          dispatch: '調度費（含遠距調度等）',
          service: '平台手續費',
          regional: '地域振興費',
          peak: '高峰調整',
          etc: '過路費（含ETC等）',
          coupon: '優惠券折扣'
        },
        notes: {
          estimate:
            '預估價根據實際交通狀況、預計行駛里程、時間以及匯率波動等因素估算得出，存在波動，僅供參考。',
          service: '平台手續費根據實際行駛里程，階梯式計算。',
          extra:
            '高速費、路橋費等行程中實際產生的其他附加費用不包含在預估價中，最終以行程結束後實際結算金額為準。'
        }
      },
      faq: {
        title: '常見問題',
        q: '問',
        a: '答',
        items: {
          why: {
            question: '為什麼實際價格比預估價格高？',
            answer:
              '在您下單前，可以看到車型的行程報價，此報價只是預估費用，如果實際價格高於預估價格，這可能是因為交通堵塞、行程中的額外停留、附加收費（如過路費）等，都會導致價格變化。'
          },
          extraFee: {
            question: '附加費是由乘客來支付嗎？',
            answer:
              '行程中產生的高速費、路橋費、停車費等附加費用，將根據實際情況由乘客承擔。'
          },
          routeChange: {
            question: '路線變更是否會影響行程價格？',
            answer:
              '若行程中因實際路況、乘客需求等原因發生路線變更，最終結算金額將以實際行駛里程和時間為準。'
          },
          cancelFee: {
            question: '取消訂單會產生取消費用嗎？',
            answer:
              '在司機接單後超過免費取消時間或司機已到達接駕點取消訂單，將根據規則收取相應的取消費用。'
          }
        }
      }
    },
    orderDetail: {
      empty: '暫無數據',
      serviceProvider: '由GO Inc. 提供本次服務',
      more: {
        title: '更多',
        orderId: '訂單號:{{orderId}}'
      },
      finding: {
        title: '正在呼叫車輛...',
        estimatedTime: '預計{{time}}分鐘內被應答，已等',
        cancelButton: '取消訂單'
      },
      remaining: '剩餘',
      minutes: '分鐘',
      meter: '米',
      kilometers: '公里',
      canceled: {
        title: '訂單已取消',
        subtitle: '如有需要，可重新呼叫用車',
        provider: '由GO Inc. 提供本次服務',
        customerService: '聯繫客服',
        paymentDetail: '預付款詳情',
        recallButton: '重新叫車',
        backHome: '返回首頁'
      },
      succeed: {
        title: '行程已結束',
        provider: '由GO Inc. 提供本次服務',
        actualPay: '實付',
        unit: '元',
        customerService: '聯繫客服',
        getInvoice: '獲取收據',
        drivingFee: '行程費金額',
        additionalPaymentAmount: '補繳金額',
        prepaid: '金額結算中',
        discount: '優惠金額'
      },
      getInvoice: {
        title: '開具電子收據',
        description: '電子收據將以郵件附件的方式發送到您的郵箱',
        invoiceTitle: '發票抬頭',
        invoiceTitlePlaceholder: '請輸入發票抬頭',
        email: '郵箱地址',
        emailPlaceholder: '請輸入郵箱地址',
        emailError: '請輸入正確的郵箱地址',
        remark: '備註',
        remarkPlaceholder: '請輸入備註',
        submit: '提交',
        success: '電子收據已發送至您的郵箱',
        error: '收據發送失敗，請稍後再試'
      },
      confirmDialog: {
        noDriver: '沒有找到附近司機，請問要重新呼叫嗎？',
        recall: '重新呼叫',
        cancel: '取消訂單',
        driverCancel:
          '司機取消訂單，本次訂單已取消，自動發起退款，稍後到賬至您的錢包',
        driverCancelConfirm: '我知道了'
      },
      rideCode: {
        title: '乘車碼',
        description: '上車後,請向司機出示以下乘車碼',
        waitingNumber: '待合わせ番号',
        destination: '目的地です'
      },
      receive: {
        cardTitle: '上車後請向司機出示您的乘車碼',
        viewCode: '查看乘車碼',
        dispatchingText: '司機已接單',
        dispatchingDescription: '司機正在趕往上車地點',
        pickUpArrivedText: '司機已到達',
        pickUpArrivedDescription: '請您盡快聯繫司機上車',
        onDeliverText: '正在前往目的地',
        onDeliverDescription: '行程已開始，請繫好安全帶',
        message: '發消息',
        cancelOrder: '取消訂單',
        shareTrip: '行程分享'
      }
    },
    repay: {
      statusText: '訂單待支付...',
      serviceProvider: '由GO Inc. 提供本次服務',
      service: '聯繫客服',
      paidText: '補交',
      unit: '元',
      feeUnit: '{{amount}}',
      repayment: '補交車費',
      drivingFee: '行程費金額',
      prepaidAmount: '預付金額'
    },
    repayDetail: {
      title: '預付款詳情',
      prepaymentAmount: '預付金額',
      actualUsage: '行程結束,實際使用',
      unusedPrepayment: '未使用預付款',
      finishedRefund: '訂單完成，未使用預付款原路退回',
      unusedPrepaymentRefund: '訂單取消，未使用預付款原路退回',
      paymentReminder: '需補繳車費，請返回支付',
      additionalFarePaid: '訂單完成，已補繳車費',
      cancelFee: '取消手續費',
      insufficientPrepaymentNotice:
        '當預付款不足以抵扣您本次出行的實際車費時，您需就不足部分繼續進行支付，否則您將無法繼續使用出行服務。',
      bankProcessingNote:
        '實際劃賬時間以銀行到賬時間為準,若7個工作日內未到賬,請聯繫客服',
      cancelFeeNote:
        '配車成功後，因乘客原因取消訂單的情況下，需支付取消手續費。',
      cny: '元',
      unit: 'JPY'
    },
    chat: {
      tips: {
        templateOnly: '僅支持發送下方模板信息',
        translation: '司乘消息將被自動翻譯成對方熟悉語言。'
      }
    },
    hotelHome: {
      title: '打車出行',
      wechatScan: {
        title: '微信掃一掃',
        description: '手機掃碼進入微信小程序，查看更多產品'
      }
    },
    hotelDropOff: {
      title: '選擇下車點'
    },
    hotelOrderConfirm: {
      title: '確認訂單',
      unit: 'JPY',
      modify: '修改'
    },
    hotelPayment: {
      title: '預付車費',
      description: '請使用手機掃描下方二維碼進行支付',
      money: '<span>JPY</span>{{amount}}',
      alertText:
        '為確保順利發單，請您按預估價支付車費，行程結束後按實際費用多退少補，預付款未使用部分將按照原路退還。'
    },
    hotelPrePayTerms: {
      title: '預付款協議',
      headDesc: `鑒於您已註冊成為"GOx旅日打車"（以下簡稱"我司"）平台用戶，並根據平台規則，在使用我司提供的出行服務時可能需要預先支付費用，特訂立本預付款協議（以下簡稱"本協議"）。
  請您仔細閱讀本協議內容，並在充分理解和同意後使用本服務。未成年人應在法定監護人的陪同下閱讀並同意本協議。您點擊"同意"或使用本服務，即視為您已閱讀、理解並接受本協議的全部內容，並願意履行相關義務，承擔相應責任。`,
      content: [
        {
          title: '預付款支付規則',
          content: [
            '為便捷您使用打車服務，我司提供預付款支付方式。在行程開始前，您需按照平台預估費用預先支付車費。',
            '預付款金額將基於您選擇或預約的出行需求，並按照平台公示的計價規則進行預估。該預付款將在您實際使用服務後用於抵扣相應費用。',
            '您確認行程並支付預付款後，訂單即正式生效。如您未支付預付款，將無法提交訂單，也無法使用我司平台內的司機服務。'
          ]
        },
        {
          title: '預付款的結算與調整',
          content: [
            '預付款僅用於打車訂單支付，不構成充值行為。',
            '訂單生效並完成行程後，系統將根據實際費用進行結算，按"多退少補"原則處理。',
            '若預付款超出實際費用，平台將在行程結束後按原支付路徑退還餘額，具體退款時間取決於銀行或第三方支付機構的處理時限。',
            '若預付款不足以支付實際費用，您需補足差額，完成支付後方可繼續使用平台服務。'
          ]
        },
        {
          title: '訂單取消與退款',
          content: [
            '在支付預付款並生成訂單後，如因非您個人原因（包括但不限於訂單未被接受、不可抗力事件等）導致行程未能完成，平台將全額退還預付款，退款路徑與支付路徑一致。',
            '若您在訂單生成後主動取消，並被認定為"有責取消"，平台將根據相應計價規則扣除費用，並退還剩餘款項。',
            '退款時限取決於銀行或第三方支付機構的處理時間，通常不超過7個工作日。如退款出現問題，您可聯繫平台客服，我們將協助與支付機構溝通處理。'
          ]
        },
        {
          title: '法律適用與爭議解決',
          content: [
            '本協議是《GOx旅日打車用戶協議》的組成部分，未盡事宜以用戶協議為準。本協議與用戶協議、隱私政策等文件共同構成本服務的法律依據。如本協議與其他相關文件存在衝突，以本協議為準。',
            '本協議適用日本法律。若因本協議引發爭議，雙方應友好協商解決；協商不成的，可提交有管轄權的法院裁決。'
          ]
        },
        {
          title: '其他條款',
          content: [
            '若本協議任何條款在任何時候被認定為不合法、無效或無法適用，但不影響整體協議效力的情況下，其他條款仍然有效。我司有權對相關條款進行合理調整，使其符合適用法律。',
            '我司保留對本協議的最終解釋權，並可根據業務需要適時修訂協議內容，修改後的協議將在平台公示，用戶繼續使用服務即視為接受修訂後的協議。'
          ]
        }
      ]
    },
    hotelPayResult: {
      success: {
        title: '支付成功',
        description: '正在跳轉'
      },
      fail: {
        title: '支付失敗',
        subtitle: '請嘗試重新下單',
        description: '請檢查您的網絡、銀行卡餘額等是否正常',
        btnText: '返回打車頁',
        seconds: '{{amount}}s'
      }
    },
    hotelOrderDetail: {
      requestSuccess: '叫車成功'
    },
    login: {
      title: '登錄/註冊',
      content: {
        title: '請選擇登錄/註冊會員的方式',
        description: '*可使用第三方賬戶輕鬆登錄、註冊會員',
        agreement:
          '*當您使用郵箱或第三方賬戶登錄時，將視同您已經同意相關<terms>{{terms}}</terms>與<privacy>{{privacy}}</privacy>',
        terms: '《使用條款》',
        privacy: '《隱私政策》'
      },
      button: {
        google: 'Google',
        email: 'Email',
        nextStep: '下一步',
        signIn: '註冊新賬戶'
      },
      email: {
        label: '郵箱'
      }
    },
    couponList: {
      title: '優惠券包',
      tabs: {
        inputCode: '輸入優惠碼',
        shareCoupon: '分享優惠碼'
      },
      inputPlaceholder: '請輸入優惠碼',
      condition: '行程總預估費超過JPY{{amount}}可用',
      applyTo: '適用於豪華型計程車',
      validUntil: '有效期至',
      minSpend: '滿JPY{{amount}}可用',
      maxDiscount: '最高減{{amount}}日元',
      noMinSpend: '無最低費用門檻',
      useButton: '去使用',
      validDate: '{{start}}至{{end}}使用',
      empty: '暫無優惠券',
      emptyTip: '快去領取優惠券吧',
      couponType: {
        NEW_USER: '新用戶折扣券',
        SHARE: '邀請券',
        SHARE_REWARD: '好友邀請返回券',
        BUNDLE: '套餐券',
        PROMOTION: '限時優惠券',
        AIRPORT_COUPON: '機場定額優惠券',
        UNKNOWN_COUPON_TYPE: '未知券'
      }
    },
    showDialog: {
      title: '分享邀請碼，共得好禮！',
      description:
        '好友邀請券請點擊「查看券包」，邀請兌換得<span>大額優惠券</span>',
      rideButton: '立即打車',
      shareButton: '分享邀請碼'
    },
    shareCoupon: {
      title: '分享邀請碼',
      headline: '邀請好友一起享受乘車優惠！',
      description:
        '邀請好友成功註冊,好友可得9.5折券(最高可以抵500日元),完成首乘後您可得200日元券(7天內使用),邀約無上限',
      description2:
        '邀請好友輸入您的專屬優惠碼後，\n好友可得<span>立減2000日元優惠券</span>，\n好友乘車後您可得<span>立減1000優惠券</span>！\n自動發放至券包，領取後15天內有效。\n可邀請多位，好友一起GO！',
      campaignDate: '（活動時間至26年10月12日，前2000名可領）',
      linkLabel: '邀請連結',
      inviteCodeLabel: '專屬邀請碼',
      copyButton: '複製',
      copySuccess: '複製成功',
      copyFailed: '複製失敗'
    },
    redeemCoupon: {
      title: '輸入優惠碼',
      codeLabel: '優惠券碼',
      placeholder: '請輸入優惠券碼',
      confirmButton: '確認兌換',
      instruction1: '*輸入優惠券兌換碼,點選【確認兌換】完成兌換;',
      instruction2:
        '*每個兌換碼僅可成功兌換一次,兌換成功後請在有效期限內使用,過期作廢。',
      emptyCode: '請輸入優惠券碼',
      redeemSuccess: '兌換成功',
      redeemFailed: '兌換失敗，請稍後再試'
    },
    getCoupon: {
      title: '領取優惠券',
      coupon: {
        title: '新用戶折扣券',
        validity: '有效期至 {{validity}}',
        discount: '{{value}}%<unit>折扣</unit>',
        minimumSpend: '滿JPY{{amount}}可用',
        usageCondition: '行程總預估費超過JPY{{amount}}可用'
      },
      button: {
        claim: '立即領取'
      },
      terms: {
        itema: '*首次註冊且未打過車的用戶可領取',
        itemb:
          '*需登入後才能領取,過期或未登入不能領取,每次掃碼僅有一次領取機會',
        itemc: '*領取成功後,可進入我的優惠券包,查看和使用',
        itemd: '*限7天內使用,過期失效'
      },
      success: {
        title: '領取成功',
        description: '優惠券已成功加入券包,可進入我的—優惠券包,查看和使用',
        viewButton: '查看優惠券',
        gotItButton: '我知道了'
      },
      newComer: {
        title: '恭喜獲得多重好禮！',
        description:
          '好友邀請券請點擊「查看券包」，分享專屬邀請碼，或輸入優惠碼兌換優惠',
        rideButton: '立即打車',
        viewButton: '查看券包',
        coupon: {
          discountUnit: '{{value}}<unit>折</unit>',
          jpyUnit: '<unit>JPY</unit>{{value}}',
          maxDiscount: '最高減{{amount}}日元',
          validity: '有效期至 {{validity}}'
        }
      }
    },
    signIn: {
      register: '註冊',
      login: '登錄',
      email: {
        label: '郵箱'
      },
      password: {
        label: '密碼'
      },
      button: {
        register: '註冊',
        signIn: '登錄'
      },
      forgetPassword: '忘記密碼？',
      validate: {
        email: {
          invalid: '請輸入正確的郵箱'
        },
        password: {
          required: '請輸入密碼'
        }
      }
    },
    reset: {
      title: '重置密碼',
      email: {
        label: '郵箱'
      },
      button: {
        reset: '發送郵件重設密碼',
        backToSignIn: '返回登錄'
      },
      sendResetEmailSuccess:
        '密碼重置鏈接已發送至 <email>{{email}}</email> 請檢查您的郵箱並重置密碼。'
    },
    service: {
      title: '客服中心',
      categories: {
        fee: '費用相關',
        driver: '司機相關',
        other: '其他問題'
      },
      items: {
        fee: {
          estimatedCost: {
            label: '預估費用',
            content:
              '預估費用會幫助您大概了解行程花費。輸入您的上下車地點後，進入下一個頁面，即可看到預估費用。預估費用是在考慮最短路徑和預估行駛時間後計算出的最優價格。實際收費可能因交通、天氣、道路施工或不同路線等因素的影響而有所差異。請知悉：預估費用僅在下單時有效。過路費或機場費等附加費用不包括在預估費用中。此報價只是預估費用，我們不能保證行程實際收費不會高於預估費用。'
          },
          costBreakdown: {
            label: '費用明細',
            content:
              '您的行程費用是綜合多種因素後計算得出，因地區和網約車供應商不同而有所差異。在計算價格的時候，供應商主要參考如下三個因素；1.起步價 2.里程費（行程距離） 3.時長費（行程時間） 其他可能影響實際費用的因素 1.動態運價，如"峰時價格"等 2.過路費和機場費 3.車輛類別 4.小程序服務費 如果實際收費與您的預期費用不同，請參考關於"實際收費高於預估費用"問題的解答。請知悉：電子收據上目前沒有費用明細。行程結束時，我們會向您發送網約車供應商計算出的實際費用。當您使用小程序時，即被視為您接受小程序上顯示的價格和扣除的費用即為行程的實際收費。實際收費有可能與出租車計價器上的價格不同。'
          },
          additionalFees: {
            label: '高速費，機場費等附加費用',
            content:
              '請注意，機場費、高速費、過路費等其他附加費用不包括在預估費用中；所有這些附加費用都需由乘客承擔。不過，司機有可能會在行程結束前將這些費用添加到實際車費中。'
          },
          cancellationFees: {
            label: '取消訂單費用',
            content:
              '為補償司機的空駛距離和時間，如果您在以下兩種情況下取消訂單，則可能需要支付訂單取消費用。1.司機接單並已經往您的上車地點行駛了一定時長或里程之後。2.司機已經到達上車地點並等待超過一定時長，在這種情況下即使司機取消訂單，您也需要支付訂單取消費用。收取訂單取消費用有助於網約車供應商保持高效運作，確保更快的派車速度。請注意，訂單取消費用可能會因地點和網約車供應商的不同而有差異。如果您認為收費不合理，請通過"聯繫客服"按鈕聯繫我們的客服團隊，我們將盡最大的努力幫助您解決。'
          },
          actualCostHigher: {
            label: '實際費用高於預估費用',
            content:
              '在您下單之前的報價只是預估費用，我們不能保證行程實際收費不會高於預估費用。如果實際收費高於預估費用，可能是由於以下原因：1.交通堵塞 2.附加收費，如過路費或機場費等 3.行程中的額外停留 4.司機選擇了另外一條路線 5.導航或是網絡問題 如果您對實際收費有任何的疑問，請通過"聯繫客服"按鈕聯繫我們的客服團隊，我們會盡力協助您解決。'
          },
          vehicleDamage: {
            label: '車輛損壞和清潔費用',
            content:
              '如果乘客弄髒了車輛，乘客需要承擔清潔費用。當出現上述情況時，司機有權在實際收費中加上清潔費。這部分費用將直接支付給司機用於車輛清潔。請乘客不要在車上進食或飲酒，協助保持車輛的乾淨整潔。'
          }
        },
        driver: {
          longerRoute: {
            label: '司機選擇了較長的行駛路線',
            content:
              '司機有權按照導航推薦選擇最快或最短路線行駛。如果行程結束時，實際收費超過了預估費用，可能是因為司機選擇了一條較長的行駛路線（為了避開交通堵塞或某些道路突發狀況）。如果您有首選路線，請在出發前與司機溝通並達成一致，以免產生任何誤解。如果實際收費明顯高於您的預期，請通過"聯繫客服"按鈕聯繫我們的客服團隊，我們會盡力協助您解決。'
          },
          orderNotEnded: {
            label: '下車後司機沒有結束訂單',
            content:
              '司機應在您下車時或不久之後立即結束訂單。如果由於司機沒有及時結束訂單而造成實際收費明顯高於預估費用，請通過"聯繫客服"按鈕聯繫我們的客服團隊，我們會盡力協助您解決。'
          }
        },
        other: {
          lostItems: {
            label: '物品丟失',
            content:
              '我們非常理解您丟失物品的急切心情，我們會盡力幫助您找回物品。請點擊下方的"聯繫客服"按鈕與我們的客服團隊溝通核實，同時請提供以下信息：1.請詳細描述您丟失的物品 2.若物品已被找回，您希望在哪裡取回物品？ 3.請留下您的電話號碼，以便我們協助找回物品後，及時與您取得聯繫 4.請問您會在此地停留多久？ 在收到以上信息之後，我們會盡快聯繫網約車供應商，並盡力幫助您找回物品。請注意因為隱私保護法，我們無法向您提供司機的聯繫方式。請知悉：我們會盡最大努力幫助您找回丟失的物品，但是無法對行程中丟失的物品擔負任何責任。'
          },
          otherIssues: {
            label: '其他問題',
            content:
              '如果您對訂單或我們的服務有其他的問題和建議，請通過下面的"聯繫客服"按鈕聯繫我們的客服團隊，我們會盡力協助您解決。'
          }
        }
      },
      contact: '聯繫客服'
    },
    terms: {
      name: 'Terms of Use',
      title: 'LINKTIVITY Terms of Use',
      lastUpdated: 'Last Updated: May 1, 2020',
      subtitle: `LINKTIVITY Terms of Use
LINKTIVITY Corporation (hereinafter referred to as "our company") has established the following LINKTIVITY Terms of Use (hereinafter referred to as "this agreement") for the use of LINKTIVITY services.

By using LINKTIVITY services, you acknowledge that you have agreed to accept the contents of this agreement. Please read this agreement carefully when using LINKTIVITY services. Additionally, this agreement may be modified as needed, so please refer to the latest content when using LINKTIVITY services.

* For information regarding the handling of personal information, please read the "Personal Information Protection Policy."`,
      content: [
        {
          title: 'Article 1 Purpose',
          content:
            'This agreement applies to users of the services of "LINKTIVITY," a platform sales website for venue rentals operated by our company. Users of this service must agree to this agreement in advance and use this service based on compliance with this agreement. This agreement may also be modified without prior notice.'
        },
        {
          title: 'Article 2 Member Registration',
          content: `1. "Member" refers to an individual who has been approved by our company to become a member. Such individual, upon agreeing to this agreement, accepting and completing the member registration procedures specified by our company, obtains this service according to these terms. However, even after approval, if our company deems the member inappropriate, approval may be revoked.
2. Information provided during member registration should be true, accurate, and valid. Individual, registration information (such as name, email address, etc.), and passwords should correspond one-to-one, and the same person should not register multiple member identities.
3. If registration information changes, members must immediately perform the prescribed change procedures.`
        },
        {
          title: 'Article 3 Information Provided by Product Suppliers',
          content:
            'Our company provides members with content, fees, available purchase dates, cancellation provisions (cancellation policies), and other purchase-related information (hereinafter referred to as "purchase-related information") provided by product suppliers on LINKTIVITY, as well as product supplier-related information. Purchase-related information is the responsibility of product suppliers, and unless our company fails to transmit information due to intentional acts or negligence, our company bears no responsibility for the content of purchase-related information.'
        },
        {
          title: 'Article 4 Contract Formation',
          content:
            'On the LINKTIVITY platform, contracts related to products purchased and services provided by members will be concluded between members and product suppliers. Posting products, services, and other content on LINKTIVITY is only for the purpose of submitting applications to product suppliers, and our company has the right to freely approve or reject such applications on behalf of product suppliers. This agreement stipulates the conditions for members to use LINKTIVITY services, including cases where members submit purchase applications to product suppliers using LINKTIVITY. However, member reservations for products and services must follow the contract conditions displayed by LINKTIVITY, information provided during the reservation process, and conditions stipulated by legal contracts related to products and services as stipulated by product suppliers.'
        },
        {
          title: 'Article 5 Fee Payment',
          content: `LINKTIVITY, as a collection agent for product suppliers, obtains payment information from members and processes payments. Members should pay fees to our company through credit cards or payment methods provided by our company when purchasing products and services. If expressed in foreign currency, our company will convert the credit card payment amount or settlement amount of payment methods provided by our company to yen according to the determined exchange rate.

However, some payments should be made through one or more methods specified on the page.`
        },
        {
          title:
            'Article 6 Content and Quality of Products and Services Provided by Product Suppliers',
          content:
            'Our company is not responsible for the content and quality of products and services provided by product suppliers. Any problems, disputes, or complaints arising between members and product suppliers, as well as any losses suffered by members, should be resolved through consultation with product suppliers, and our company bears no responsibility for this.'
        },
        {
          title: 'Article 7 Usage Environment',
          content: `1. When using LINKTIVITY, members should prepare necessary communication equipment, software, communication means, and other products and services on their own, and bear full responsibility and costs incurred during the period.
2. When using LINKTIVITY, members should prepare necessary smartphones, software, communication means, and other products and services that can connect to the network on their own, and bear full responsibility and costs incurred during the period.`
        },
        {
          title:
            'Article 8 Order Cancellation and Cancellation Fees Due to Member Reasons',
          content: `1. Cancellation fees incurred when members cancel orders due to their own reasons will be charged according to the cancellation terms (cancellation policies) stipulated by product suppliers.
2. Our company bears no responsibility for foreign exchange gains and losses caused during payment and refund.
3. In principle, members need to log into the "Personal Page" of LINKTIVITY and cancel reservations. However, if they contact product suppliers before the usage date and product suppliers accept order cancellation, cancellation procedures can be completed by notifying LINKTIVITY through the "Personal Page" later.`
        },
        {
          title:
            'Article 9 Order Cancellation and Refunds Due to Product Suppliers',
          content:
            'When product suppliers change or cancel products and services, they should directly notify members, and our company bears no responsibility for changes or cancellations of products and services. However, according to decisions or requirements of product suppliers, if the content of sold products or services changes or is cancelled, our company may handle refunds for products or services on their behalf.'
        },
        {
          title: 'Article 10 Password Management',
          content: `1. Members are responsible for and should manage passwords.
2. Members should not provide email addresses and passwords to third parties for use, and should not lend, transfer, rename, sell, mortgage, etc.
3. Damage liability caused by improper password management, usage errors, or third-party usage by members is borne by members themselves, and our company bears no responsibility.`
        },
        {
          title: 'Article 11 Handling of Member Registration Information',
          content: `1. During member registration, personal information provided by members (hereinafter referred to as "registration information") will be managed and stored by our company according to our company's personal information protection policy.
2. Our company will not disclose to third parties information containing personally identifiable information (hereinafter referred to as "personal information"). However, the following cases are excluded:

   i. When disclosing information with customer consent

   ii. When providing personal information necessary for service performance to business outsourcing companies that have signed personal information protection confidentiality agreements

   iii. When conducting statistical analysis of personal information for service improvement and disclosing or providing to third parties in a state where personal identity cannot be identified or determined

   iv. When disclosure is required according to search warrants issued by courts or court judgments

Additionally, please read the "Personal Information Protection Policy" to understand the personal information obtained by our company, usage purposes, and processing details.`
        },
        {
          title: 'Article 12 Prohibited Items for Members',
          content: `When using LINKTIVITY, members should not engage in the following behaviors or behaviors that may lead to the following:

1. Behaviors that violate this agreement
2. Behaviors that violate public order and morals or laws and regulations
3. Behaviors that infringe on copyrights, portrait rights, or other intellectual property rights of our company, other members, or third parties
4. Behaviors that defame or slander other members or third parties
5. Behaviors that bring adverse effects to other members or third parties
6. Behaviors that interfere with our company's business or hinder our company's service operations
7. Profit-making behaviors
8. Behaviors of transferring or lending rights obtained as members to third parties without prior consent of our company
9. Other behaviors that our company deems inappropriate`
        },
        {
          title:
            'Article 13 Deletion or Correction of Information Sent by Members',
          content: `Our company may delete part or all of the information sent by members that conforms to or may belong to any of the following items, or make any corrections that our company deems necessary, without member consent:

1. Information that our company deems to conform to the "Member Prohibited Items" of this agreement
2. Information that our company judges to be inconsistent with facts
3. Other situations that our company deems inappropriate`
        },
        {
          title: 'Article 14 Cancellation of Member Status',
          content: `If members fall under any of the following situations, our company may cancel member status without prior notice to members, and bears no responsibility to members:

1. One of the situations that violate the "Member Prohibited Items" of this agreement
2. Other violations of this agreement
3. Other situations where our company deems the member unsuitable for member status`
        },
        {
          title: 'Article 15 Service Changes, Suspension, and Termination',
          content: `1. Our company may change, suspend, or terminate service content without prior notice to members.
2. When any disadvantages or losses are caused to members due to changes, suspension, or termination of this service content, our company bears no responsibility.
3. Our company may notify members one month in advance and terminate service provision.`
        },
        {
          title: 'Article 16 Copyright and Property Rights',
          content:
            'All content displayed on LINKTIVITY is copyrighted and owned by our company and individuals or entities such as product suppliers, partners, and advertisers who provide such content to our company. Unless prior written consent is obtained from our company, product suppliers, partners, and advertisers, users and members agree not to copy, disclose, transfer, lend, translate, reprint, transmit, use, or reuse such content. Additionally, our company has the right to claim compensation from users and members for amounts equivalent to benefits obtained during the above-mentioned behaviors.'
        },
        {
          title: 'Article 17 Disclaimer and Liability Limitation',
          content: `1. Our company bears no responsibility for any damages occurring between our company and product suppliers, any damages caused by members violating this agreement, or damages caused by non-company reasons during product or service exchange processes.
2. Product suppliers are independent contract entities from our company. Our company bears no responsibility for any damages or other damages caused by injuries, deaths, property losses, theft, or terrorist attacks when members participate in product activities or enjoy services due to behaviors, negligence, omissions, agency behaviors, guarantees, etc. of product suppliers.
3. Our company bears no responsibility for events such as delays, cancellations, duplicate purchases, strikes, etc. of products or services beyond our company's direct management scope. Additionally, when content changes, cancellations, delays, additional costs, etc. occur due to government agencies, court orders, etc., our company bears no response obligations.
4. When our company provides this service, if members directly or indirectly suffer losses beyond actual, ordinary losses, even if our company has intentional or negligent acts, our company bears no responsibility.`
        },
        {
          title: 'Article 18 Changes to This Agreement',
          content:
            'Our company reserves the right to change the content of this agreement when necessary. When modifying this agreement, changes are considered completed by simply making modifications on this page, and members will not be notified individually.'
        },
        {
          title: 'Article 19 Jurisdiction',
          content:
            'For any disputes regarding this agreement, the Tokyo District Court will be the exclusive court of first instance.'
        },
        {
          title: 'Article 20 Consultation',
          content:
            'For matters not stipulated in this agreement or any questions about this agreement, both parties should negotiate in good faith and make friendly efforts to find solutions together.'
        },
        {
          title:
            '* This is a translated version, the original text shall prevail.',
          content: ''
        }
      ]
    },
    privacy: {
      title: 'Privacy Policy',
      lastUpdated: 'Last Updated: March 18, 2022',
      company: 'LINKTIVITY Corporation',
      contentTitle: 'Personal Information Protection Policy',
      subTitle:
        "Our company collects users' personal information through LINKTIVITY, a reservation website operated by our company. Our company believes that protecting users' personal information is very important to allow users to book products with peace of mind and convenience, so our company handles personal information by complying with the following provisions:",
      content: [
        {
          title: 'Manager of User Personal Information',
          content:
            'LINKTIVITY Corporation\n〒100-0011 19F, Hibiya Park Front, 2-1-6 Uchisaiwai-cho, Chiyoda-ku, Tokyo'
        },
        {
          title: 'Information Collection',
          content:
            "Except in cases required by law, our company collects the minimum necessary personal information from users after obtaining their consent to achieve our company's usage purposes."
        },
        {
          title: 'Information Usage',
          content:
            'Our company only uses personal information collected from users when achieving the usage purposes stipulated by our company.'
        },
        {
          title: 'Storage and Preservation',
          content:
            'Our company performs storage and preservation work on personal information to ensure that personal information obtained from users does not leak, and ensures system security.'
        },
        {
          title: 'Destruction and Deletion',
          content:
            'When personal data (referring to personal information stipulated by the Personal Information Protection Law, the same applies hereinafter) is no longer needed for use, our company will destroy it promptly.'
        },
        {
          title: 'User Consultation and Other Processing',
          content:
            'For user requests to inform usage purposes, disclosure requests, correction/addition/deletion requests, stop usage/deletion requests, and stop provision to third parties, our company will process them according to legal requirements.'
        },
        {
          title: 'Security Management Measures and Others',
          content:
            'Our company will educate all employees related to LINKTIVITY services to understand the importance of personal information and take necessary and appropriate measures to manage the security of personal information.'
        }
      ],
      rules: [
        {
          title:
            '1. Personal Information Obtained by Our Company and Its Usage Purposes',
          subtitle:
            "Our company will collect and use users' personal information such as address, name, date of birth, contact information, email address, or passport number for the following purposes. Additionally, without user consent, our company will not collect personal information that requires special attention. When collecting personal information from users, if the personal information usage purpose is not publicly disclosed, the personal information usage purpose should be informed to users or publicly displayed. Furthermore, without parental consent, our company will not collect personal information from children under 13 years old. When our company collects personal information from children under 13 years old, it will be deemed that guardian consent has been obtained, but if there is clearly no consent, our company will not use that personal information for purposes other than contacting guardians.",
          rule: [
            {
              title:
                'i. LINKTIVITY Service Usage (Member Registration, etc.) Purpose',
              content:
                'To use LINKTIVITY services, our company will share user personal information within the company.\nLegal basis: Necessary to provide services or functions requested by users.'
            },
            {
              title: 'ii. Ticket Purchase Application',
              list: [
                {
                  title: 'Personal Information Collection Items',
                  content:
                    "When users apply to product suppliers to purchase tickets, our company will collect users' names, payment information, passport numbers, and information related to users' health conditions, etc."
                },
                {
                  title: 'Specific Usage Purposes',
                  content:
                    "Our company will collect users' personal information to confirm users' ticket purchase eligibility and payment matters. Additionally, to achieve this purpose, our company will provide users' personal information to product suppliers, transportation agencies, payment settlement providers (including overseas providers, etc.), etc."
                }
              ],
              subtitle:
                "Legal basis: To meet users' service needs and provide necessary functions."
            },
            {
              title:
                'iii. To send notifications to users, including newsletters (email magazines, etc.), our company will collect personal information after user consent',
              content:
                'Legal basis: Information collection based on user consent.'
            },
            {
              title:
                'iv. Advertising delivery through social media and advertising platforms',
              content:
                'Legal basis: Information collection based on user consent.'
            },
            {
              title: 'v. To request questionnaire completion',
              content:
                "Legal basis: Collecting personal information based on user consent to improve our company's reservation website, products, services, and other content."
            },
            {
              title: 'vi. To analyze and manage user information',
              content:
                "Legal basis: To pursue and protect users' legitimate interests by improving our company's reservation website, products, services, and other content."
            },
            {
              title: 'vii. To detect unauthorized use of credit cards, etc.',
              content:
                "Legal basis: Necessary to ensure the security of users' credit cards to pursue and protect users' legitimate interests."
            }
          ]
        },
        {
          title: '2. Third-Party Provision of Personal Information',
          subtitle:
            "Our company will not provide users' personal information obtained to third parties, except in the following cases:\n\ni. When users provide personal information to third parties (including product suppliers, overseas travel agencies, social media operators, advertising service companies, and other businesses). When users have previously agreed to provide personal information to third parties through consent to this privacy policy or other means.\nii. When entrusting external organizations to process personal information within the necessary scope.\niii. When providing personal information is required by law.\niv. When it is necessary to protect an individual's life, body, or property and user consent cannot be obtained.\nv. When it is particularly necessary to improve public health or promote healthy child development and user consent cannot be obtained.\nvi. When cooperating with national and local governments to execute legal affairs, and obtaining user consent may affect the execution of those affairs.",
          rule: []
        },
        {
          title: '3. Entrustment of Personal Information Processing',
          subtitle:
            "When the company, in necessary cases, entrusts users' personal information to third parties based on the above provisions, it will provide necessary and appropriate supervision to the entrusted party to achieve the company's purposes. If the entrusted party re-entrusts, the company will directly or indirectly supervise whether the entrusted party provides necessary and appropriate supervision to the re-entrusted party. The same applies to cases of re-re-entrustment.\nIf our company, according to the above provisions, entrusts users' personal information to third parties within the necessary scope to achieve our company's usage purposes, our company will provide necessary and appropriate supervision to the entrusted party. Additionally, if the entrusted party re-entrusts data, our company will directly or indirectly supervise whether the entrusted party provides necessary and appropriate supervision to the re-entrusted party. The same should apply to cases where the re-entrusted party re-entrusts.",
          rule: []
        },
        {
          title: '4. Obtaining Cookie Information, etc.',
          rule: [
            {
              title: 'i. Cookies',
              content:
                "Cookies are pieces of data stored on users' hard drives containing information about users. Our company does not use cookies as personal identification information. Additionally, since they are temporary cookies, once users close their browsers, cookies will not be saved. Our company uses cookies to improve service quality, customize our company's website, and measure advertising effectiveness.\nAdditionally, our company analyzes cookies as statistical data to detect users' interests and concerns and prevent unauthorized access.\nUsers can disable cookies according to their needs, but this will prevent users from making reservations on LINKTIVITY."
            },
            {
              title: 'ii. Logs/Files',
              content:
                'Our company automatically collects specific information and saves it in log files. This specific information includes IP (Internet Protocol) addresses, browser types, ISP (Internet Service Provider), referrer/exit pages, operating systems, date/time stamps, etc. Our company uses this information to monitor unauthorized access. Additionally, our company conducts user trend analysis, website management, and user behavior tracking.\nHowever, when using the above information, our company ensures that specific individuals are not identified and that the obtained information is not used for any purposes other than those mentioned above.'
            },
            {
              title: 'iii. Web Beacons',
              content:
                'Our company uses Web Beacons for access analysis and affiliate programs. Our company will not use Web Beacons for any purposes other than those mentioned above, nor will they be used to identify specific individuals.'
            },
            {
              title: 'iv. Statistical Analysis',
              content:
                "Our company uses third-party access analysis tools to confirm which websites and services are popular and record users' access pages and page history within the LINKTIVITY website.\nOur company uses this data to provide LINKTIVITY content and advertisements that match the interests of users interested in specific areas.\nAdditionally, our company may collect statistical information unrelated to personal identity. Furthermore, cookie information collected by our company and cookie information collected by other companies may be mutually viewed on third-party access analysis tools."
            }
          ]
        },
        {
          title: '5. Processing of Anonymized Information',
          rule: [
            {
              title: '1. Creation of Anonymized Information Processing:',
              content:
                'Our company will comply with the following provisions when creating anonymized information. Anonymized information processing refers to personal information-related information obtained by processing personal information, taking legally stipulated measures that cannot identify specific individuals and cannot restore the original personal information.\n\n1) Follow legally stipulated standards and perform appropriate processing;\n2) Take security measures according to legally stipulated standards to prevent leakage of deleted information or information processing methods;\n3) Publicly disclose information items that have been processed into anonymized information;\n4) Take no action to perform personal identification behavior.'
            },
            {
              title: '2. Provision of Anonymized Information',
              content:
                'If anonymized information is to be provided to third parties, our company should publicly disclose the personal information-related items in the anonymized information to be provided and the provision method, and clearly inform the third party receiving the information that it is anonymized information.'
            },
            {
              title: '3. Regarding Disclosure of Anonymized Information',
              content:
                'Regarding the creation of anonymized information\nFor the following users\' personal information, our company will continuously create anonymized information while taking appropriate measures to ensure that specific individuals cannot be identified and personal information cannot be restored.\n\nPersonal information-related items contained in anonymized information\nInformation obtained for providing platform services\nPurchase date, participation date, coupon language, sales price range, number of participants, reservation status (confirmed reservation or cancellation, etc.), supplier location area and prefecture information, travel agency country/region\n\nProvision of anonymized information to third parties\nFor anonymized information created or held by our company, our company will continuously provide it to third parties after clearly indicating that it is anonymized information.\n\nPersonal information-related items contained in anonymized information\nSame items as "Personal information-related items contained in anonymized information" in "Regarding the creation of anonymized information" above\n\nProvision method\nSend password-protected electronic files through electronic communication methods (email, server upload, API links, etc.) or physical media such as DVDs.'
            }
          ]
        },
        {
          title: '6. Security Management Measures for Personal Information',
          subtitle:
            'To prevent personal information leakage, theft, misuse, unauthorized access, tampering, and destruction, our company has implemented organizational, technical, and physical security management measures. Access to servers storing personal information by our company is limited to specific employees holding ID/PW, and particularly for certain personal information management, only the minimum number of employees required for data management are allowed access.\n\nAdditionally, personal information including credit card information is distributed across multiple data centers and stored in secure environments. We also use Secure Socket Layer (SSL) encryption on all reservation transaction pages. By using SSL-enabled browsers, you can keep personal information and credit card information transmitted over the Internet confidential.\n\nAdditionally, employees handling user personal information will use password-protected screen savers when leaving terminals.\n\nFurthermore, our company conducts education and training on the importance of personal information and other matters once a month for some departments and at least once every six months for the entire company, and retains education records.',
          rule: []
        },
        {
          title: '7. Rights Regarding User Personal Information Processing',
          subtitle:
            'According to the EU General Data Protection Regulation (GDPR) 2016/679 effective from April 27, 2016, regarding the processing of personal information, users have the following rights:',
          rule: [
            {
              title: 'i. Right of Access'
            },
            {
              title: 'ii. Right of Rectification'
            },
            {
              title:
                'iii. Right to Erasure (Right to be Forgotten) and Right to Restrict Processing'
            },
            {
              title: 'iv. Right to Data Portability'
            },
            {
              title: 'v. Right to Object'
            },
            {
              title:
                'vi. Right not to be Subject to Decisions Based on Automated Processing (Including Profiling).'
            }
          ]
        },
        {
          title:
            '8. Requests for Disclosure, Correction, Cessation of Use, etc.',
          subtitle:
            'Our company will respond to the following requests through the contact window listed in Article 11 below: usage purposes provided by users, disclosure requests, correction/addition/deletion requests, cessation of use, deletion requests, and suspension of provision to third parties of retained personal information (hereinafter collectively referred to as "disclosure requests, etc.").\n\nAdditionally, our company may also change and confirm member information on users\' personal pages and stop services such as email magazines according to user requests.',
          rule: []
        },
        {
          title: '9. External Links',
          subtitle:
            'The LINKTIVITY website contains links to other websites. This privacy policy only applies to information collected by the LINKTIVITY website, and our company bears no responsibility for the privacy policies or content of other websites. When users visit other linked websites, it is recommended to read their privacy policies and confirm how they handle personal information.',
          rule: []
        },
        {
          title: '10. Changes to Privacy Policy',
          subtitle:
            'Our company publishes the privacy policy on the LINKTIVITY website to enable users to know the purposes for which our company obtains and uses user personal information and what information our company collects. Additionally, if the privacy policy changes, it will also be published on the LINKTIVITY website to make it public to users.',
          rule: []
        },
        {
          title: '11. Contact Information',
          subtitle:
            "If you have questions about our company's privacy policy, personal information protection measures, collection and use of personal information, or requests for disclosure, etc., please contact us using the information below, and our company staff will respond within 5 business days.\n\nLINKTIVITY Corporation\n〒100-0011 19F, Hibiya Park Front, 2-1-6 Uchisaiwai-cho, Chiyoda-ku, Tokyo\n\nData Protection Officer Contact: dpo@linktivity.co.jp",
          rule: []
        },
        {
          title:
            '* This is a translated version, the original text shall prevail.',
          rule: []
        }
      ]
    }
  },
  cancelTerms: {
    title: '取消規則',
    textTitle: 'GOx旅日打車取消規則',
    content: [
      {
        title: '取消費說明',
        content: [
          '當司機接單超過3分鐘或已到達上車點時，若您取消訂單，供應商可能會收取取消費。',
          '由於不同供應商的取消費規則可能存在差異，具體費用標準請以供應商提供的信息為準。'
        ]
      },
      {
        title: '取消費用用途',
        content: [
          '平台收取的取消費將用於補償司機因行程取消所產生的空駛成本，以保障司機權益。'
        ]
      },
      {
        title: '您需支付取消費的情況',
        content: [
          '若您在超過規定時間後取消訂單，導致司機產生空駛成本，您需要支付取消費作為補償。',
          '具體取消費用標準將依據供應商的規則計算，系統將在取消時向您展示相應的費用。'
        ]
      },
      {
        title: '您無需支付取消費的情況',
        content: [
          '在規定時間內取消訂單，您無需支付取消費。',
          {
            title: '若因以下原因取消訂單，取消費可予以免除：',
            content: [
              '司機主動取消訂單',
              '司機未按預定時間到達上車點',
              '司機拒載或無故不來接乘客',
              '其他因司機原因導致的訂單無法正常進行'
            ]
          },
          '若因上述情況產生取消費，您可聯繫客服申訴，平台將在核實後進行取消費豁免處理。'
        ]
      },
      {
        title: '爭議處理',
        content: [
          '若您對取消費用有異議，可在訂單取消後24小時內聯繫客服進行申訴。',
          '平台將依據訂單記錄、司機反饋及相關證據進行核實，並在核實完成後做出最終處理決定。'
        ]
      }
    ],
    bottomDesc: '感謝您選擇GOx旅日打車平台，祝您出行愉快！'
  },
  components: {
    confirm: {
      confirm: '確定',
      cancel: '取消'
    },
    map: {
      locationPermission: {
        harmony:
          '無法取得您的位置。請前往手機「設定 > 應用程式和元服務 > 位置」開啟定位服務，並允許本服務使用位置資訊。',
        wechat:
          '無法取得您的位置。請前往手機「設定」開啟定位服務，並允許微信使用位置資訊。',
        ios: '無法取得您的位置。請前往「設定 > 隱私權與安全性 > 定位服務」開啟定位服務，並允許目前的瀏覽器使用位置資訊。',
        android:
          '無法取得您的位置。請前往手機「設定 > 位置資訊」開啟定位服務，並在瀏覽器的網站設定中允許本網站使用位置資訊。',
        default: '無法取得您的位置。請在瀏覽器設定中允許本網站使用位置資訊。'
      },
      locationPermissionConfirm: '我知道了'
    },
    hotel: {
      back: '返回',
      multiLanguage: 'EN/中/日/한'
    }
  },
  common: {
    noData: '暫無數據',
    copyright: '© LINKTIVITY Inc. All Rights Reserved.'
  },
  errorCode: {
    [ErrorCode.Internal]: '系統繁忙，請稍後再試',
    [ErrorCode.Unauthorized]: '登錄已過期，請重新登錄',
    [ErrorCode.InvalidArgument]: '輸入信息有誤，請重新輸入',
    [ErrorCode.PaymentFailed]: '支付失敗，請重新嘗試',
    [ErrorCode.PendingPaymentExist]: '您有未完成的支付訂單，請先處理',
    [ErrorCode.PaymentNotCompleted]: '支付尚未完成，請繼續支付',
    [ErrorCode.LoginFailed]: '登錄失敗，請重新嘗試',
    [ErrorCode.RefundFailed]: '退款失敗，請聯繫客服處理',
    [ErrorCode.AccessTokenExpired]: '登錄已過期，請重新登錄',
    [ErrorCode.TaxiNotFound]: '暫無可用車輛，請稍後再試',
    [ErrorCode.InvalidLocation]: '位置信息無效，請重新選擇',
    [ErrorCode.NotCancellable]: '當前訂單狀態不可取消',
    [ErrorCode.DeadlineExceeded]: '系統繁忙，請稍後再試',
    [ErrorCode.CouponNotFound]: '該優惠券不存在',
    [ErrorCode.CouponExpired]: '優惠券已過期',
    [ErrorCode.CouponAlreadyUsed]: '優惠券已使用',
    [ErrorCode.CouponNotApplicable]: '優惠券不適用',
    [ErrorCode.CouponAlreadyRedeemed]: '您已兌換過此類優惠券',
    [ErrorCode.CouponOutOfAllotment]: '優惠券已發放完',
    [ErrorCode.CouponEventEnded]: '優惠券活動已結束',
    [ErrorCode.CouponEventNotStarted]: '優惠券活動尚未開始'
  },
  firebase: {
    'auth/wrong-password': '登錄名或密碼錯誤',
    'auth/user-not-found': '登錄名或密碼錯誤',
    'auth/email-already-in-use': '郵箱已存在',
    'auth/too-many-requests': '登錄嘗試次數超過上限。請稍後再試，或重置密碼。'
  }
};
